import { useNavigate } from "react-router-dom"
import banner from './../../assets/banner.png';
import data from './../../assets/data.png';
import upload from './../../assets/upload.png';
import tags from './../../assets/tags.png';

const LandingPage = () => {
  const navigate = useNavigate();
  const getStartedEvent = () => {
    navigate("/data-upload");
  }

  const cardContents = [
    {
      title: "Dashboard for Data Visualization (Coming Soon)",
      description: "Visualize your uploaded datasets with interactive charts and dashboards. Gain actionable insights and monitor your data in real-time.",
      image: data
    },
    {
      title: "Multiple Upload Methods",
      description: "Easily upload your data using drag-and-drop, file selection, CLI or API integration. Flexible options to suit your workflow.",
      image: upload
    },
    {
      title: "Tags for Indexing",
      description: "Organize and categorize your datasets with customizable tags. Quickly search and filter your data for efficient management.",
      image: tags
    }
  ];
  return (
    <main className='landing-page-main fill--1'>       
      <div className="banner-container">
        <div className="image">
          <img src={banner} alt='Data Upload Banner'/>
        </div>
        <div className="contentLeft">
          <h1>Trinity - SUMO (Smart Upload for Multi-modal Objects)</h1>
          <h3>Data Upload</h3>
          <p>
            Seamlessly upload, organize, and visualize your data with our intuitive platform. 
            Unlock insights faster and accelerate your AI workflows with robust tools designed for modern data teams.
          </p>
          <div className="flex u-mt++">
            <eds-button
              variant="secondary"
              type="button"
              label="Get started"
              icon='{"name": "ico-arrow-right-16", "position": "left"}'
              onClick={getStartedEvent}
              class="u-mr"
            ></eds-button>
          </div>
        </div>
      </div>

      <div className="contentHeading">
        <h2>Our Offerings</h2>
      </div>

      <div className="contentContainer">
        {cardContents.map((content, index) => (
          <div className="cardPanel" key={index}>
            <eds-card variant="option-1" elevation="" notch-size="" width="fit-content" height="100%">
              <div slot="main-images">
                <img src={content.image} alt={content.title} className="cardImage" />
              </div>
              <div slot="main-content">
                <h4 className="u-m0 u-mb-- text-bold">{content.title}</h4>
                <p>{content.description}</p>
              </div>
            </eds-card>
          </div>
        ))}
      </div>
    </main>
  );
}

export default LandingPage;
